module.exports = __webpack_public_path__ + "img/06.0be41fc3.png";